import React, { useState, useEffect } from 'react';
import { showToast } from "../../Shared/ToastMessage";
import axios from "axios";
import { baseUrl, ROUTE_BASE_URL, commonBaseUrl } from "../../../api/common";
import { useHistory } from "react-router-dom";
import Cookies from 'js-cookie';
import logo from '../../../assets/images/logo.png';
import { encryptSlug } from '../../../util/encryption';
export default function OtpVerify({ adminId, email }) {

  const history = useHistory();

  const [otp, setOtp] = useState(["", "", "", ""]);

    // Timer states
    const [otpExpiryTime, setOtpExpiryTime] = useState(180) // 5 minutes in seconds
    const [resendTime, setResendTime] = useState(60) // 60 seconds cooldown
    const [canResend, setCanResend] = useState(false)
  
    // Format time as MM:SS
    const formatTime = (timeInSeconds) => {
      const minutes = Math.floor(timeInSeconds / 60)
      const seconds = timeInSeconds % 60
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`
    }
  
    // Calculate progress percentage for the timer bar
    const calculateProgress = (current, total) => {
      return (current / total) * 100
    }
  
    // Initialize timers on component mount
    useEffect(() => {
      // OTP expiry timer
      const expiryInterval = setInterval(() => {
        setOtpExpiryTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(expiryInterval)
            // showToast("OTP has expired. Please request a new one.", "warning")
            return 0
          }
          return prevTime - 1
        })
      }, 1000)
  
      // Resend cooldown timer
      const resendInterval = setInterval(() => {
        setResendTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(resendInterval)
            setCanResend(true)
            return 0
          }
          return prevTime - 1
        })
      }, 1000)
  
      // Cleanup intervals on unmount
      return () => {
        clearInterval(expiryInterval)
        clearInterval(resendInterval)
      }
    }, [])
  
    // Reset resend timer after requesting new OTP
    const resetResendTimer = () => {
      setResendTime(60)
      setCanResend(false)
    }

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (value.match(/^\d?$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);      
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  // const resendOtp = async () => {
  //   if (!canResend && resendTime > 0) return
  //   try {
  //     const { data } = await axios.post(`${baseUrl}/api/member_resend_otp`, { id: adminId }, {
  //       headers: { "Content-Type": "application/json", Authorization: localStorage.getItem("access_token") }
  //     });
  //     showToast(data.message, data.status ? "success" : "error");
  //   } catch {
  //     showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
  //   }
  // };
  const resendOtp = async () => {
    if (!canResend && resendTime > 0) return

    try {
      const { data } = await axios.post(
        `${commonBaseUrl}/api/common_member_resend_otp`,
        { id: adminId },
        {
          headers: { 
            "Content-Type": "application/json",
            "X-Source": "web", 
            Authorization: localStorage.getItem("access_token") 
          },
        },
      )

      if (data.status) {
        // Reset OTP expiry timer
        setOtpExpiryTime(180)
        // Reset resend cooldown
        resetResendTimer()
      }

      showToast(data.message, data.status ? "success" : "error")
    } catch {
      showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error")
    }
  }

  const verifyOtp = async () => {
    if (otpExpiryTime <= 0) {
      // showToast("OTP has expired. Please request a new one.", "warning");
      return
    }
    try {
        const enteredOtp = otp.join("");
        const response = await axios.post(`${commonBaseUrl}/api/common_member_otp_verify`, { id: adminId, otp: enteredOtp }, {
        headers: { 
          "Content-Type": "application/json",
          "X-Source": "web",
          Authorization: localStorage.getItem("access_token") 
        }
      });

      if (response.data.status) {
        showToast(response.data.message, "success");
        // Cookies.set('eventMemberUserId', data.userid, { expires: 1 });
        // localStorage.setItem('loginEventMemberUserId', data.userid);      
        // const fullName = `${user.first_name}${user.middle_name ? ' ' + user.middle_name : ''}${user.last_name ? ' ' + user.last_name : ''}`;
        // localStorage.setItem('loginEventMemberUserName', fullName);
        // localStorage.setItem('loginEventMemberUserImage', user.profile);
        // setOtp(["", "", "", ""]);
        const user = response.data.data[0];
        const eventUser = response.data.event_data[0];
        const isMember= response.data.member;
        const isEventMember= response.data.event;
        localStorage.setItem('isMember', isMember);
        localStorage.setItem("isEventMember", isEventMember);
        if(isEventMember===1){
          // Store user details
          Cookies.set("eventMemberUserId", response.data.event_data[0].id, { expires: 1 });
          localStorage.setItem("loginEventMemberUserId", response.data.event_data[0].id);
          const fullName = `${eventUser.first_name}${eventUser.last_name ? ' ' + eventUser.last_name : ''}`;
          localStorage.setItem('loginEventMemberUserName', fullName);
          localStorage.setItem("loginEventMemberEmail", eventUser.email);
        }
        if(isMember===1){
          // Cookies.set("memberUserId", response.data.data[0].id, { expires: 1 });
          localStorage.setItem("loginMemberUserId", response.data.data[0].id);
          const fullName = `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}`;
          localStorage.setItem('loginEventMemberUserName', fullName);
          localStorage.setItem("loginEventMemberEmail", user.email);
      }
       history.replace(`/events/user-events/${encryptSlug(email)}`);
      } else {
        showToast(response.data.message, "error");
      }
    } catch {
      showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
    }
  };

  return (
    <>
      <div className="auth-main particles_js">
        <div className="auth_div vivify popIn">
          <div className="auth_brand">
            <img
              src={logo}
              width="80"
              height="80"
              className="d-inline-block align-top mr-2"
              alt="Logo"
            />
          </div>
          <div className="card forgot-pass">
            <div className="body">
              <p className="lead mb-3">
                <strong>Verification</strong>
                <br />
                Please enter OTP
              </p>

              {/* OTP Expiry Timer */}
              <div className="otp-timer mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1 text_cap">
                  <span>Code expires in:</span>
                  <span>{formatTime(otpExpiryTime)}</span>
                </div>
                <div className="progress" style={{ height: "4px" }}>
                  <div
                    className="progress-bar bg-primary"
                    role="progressbar"
                    style={{ width: `${calculateProgress(otpExpiryTime, 180)}%` }}
                    aria-valuenow={otpExpiryTime}
                    aria-valuemin="0"
                    aria-valuemax="180"
                  ></div>
                </div>
              </div>

              <div className="form-group">
                <div className="otp_field">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      className="form-control"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                    />
                  ))}
                </div>
              </div>

              <button
                onClick={verifyOtp}
                className="btn btn-outline-primary btn-lg btn-block mb-2"
                disabled={otp.includes("") || otpExpiryTime <= 0}
              >
                Verify OTP
              </button>

              <div className="bottom d-flex justify-content-between align-items-center">
                <span className="helper-text">Check your inbox & spam folder</span>
                <span className="helper-text">
                  <button
                    onClick={resendOtp}
                    className="btn btn-link"
                    type="button"
                    disabled={!canResend && resendTime > 0}
                  >
                    {canResend ? "Resend OTP" : `Resend in ${resendTime}s`}
                  </button>
                </span>
              </div>

              {/* <div className="text-center mt-3">
                <a href="#" className="text-primary">
                  Not receiving the email?
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div id="particles-js"></div>
      </div>
    </>
  );
}
